(function () {
    var map;
    var markers = [];
    var drawingManager;

    var addTooltips = function() {
        setTimeout(function(){
            $(".gmnoprint").each(function(){
                addTooltip($(this), 'Stop drawing', 'Click here to stop the drawing');
                addTooltip($(this), 'Add a marker', 'Click here to add a marker to your map');
                addTooltip($(this), 'Draw a shape', 'Click here to draw a shape in your map');
            });

            $('.mapTooltip').tooltip();
        }, 2000);
    };

    var addTooltip = function(obj, key, title) {
        var polygon = obj.find("[title='" + key + "']");
        polygon.attr('data-tooltip', title);
        polygon.attr('data-position', 'bottom');
        polygon.addClass('mapTooltip');
    };

    /**
     * Return map center based on property or country if property has not center.
     * @returns {{lat: number, lng: number}}
     */
    var getCenter = function() {
        var lat = $("input[name='latitude']").val();
        var long = $("input[name='longitude']").val();

        var center = {};
        if(lat.length > 0 && long.length > 0) {
            center = {
                lat: parseFloat(lat),
                lng: parseFloat(long)
            };
        }

        return center.lat && center.lng ? center : Utils.getUSACenter();
    };

    /**
     * Add a marker to the map from a click event.
     * @param marker
     */
    function addMarker(marker) {
        var latPinEl = $("input[name='map_pin_lat']");
        var lngPinEl = $("input[name='map_pin_lng']");
        var latitude = $("input[name='latitude']");
        var longitude = $("input[name='longitude']");

        latPinEl.val(marker.getPosition().lat());
        lngPinEl.val(marker.getPosition().lng());
        latitude.val(marker.getPosition().lat());
        longitude.val(marker.getPosition().lng());

        clearMarkers();
        markers.push(marker);
    }

    function addCustomControl(controlDiv, type) {
        if(type === 'polygon') {
            addSpecificCustomControl(controlDiv, 'Clear selected area from the map', '<i class="small material-icons" style="font-size: 20px !important;">clear</i>', clearSelection);
        } else if(type === 'marker') {
            addSpecificCustomControl(controlDiv, 'Clear pin from the map', '<i class="small material-icons" style="font-size: 20px !important;">clear</i>', clearMarkers);
        }
    }

    var addSpecificCustomControl = function(controlDiv,tooltip, icon, callback) {
        var ui = document.createElement('div');
        ui.style.backgroundColor = '#fff';
        ui.style.border = '2px solid #fff';
        ui.style.borderRadius = '2px 2px 2px 2px';
        ui.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        ui.style.cursor = 'pointer';
        ui.style.marginBottom = '22px';
        ui.style.marginTop = '5px';
        ui.style.marginLeft = '5px';
        ui.style.textAlign = 'center';
        ui.style.height = '23px';
        ui.style.width = '23px';
        ui.classList.add("mapTooltip");
        ui.setAttribute("data-position", "bottom");
        ui.setAttribute("data-tooltip", tooltip);
        controlDiv.appendChild(ui);

        var button = document.createElement('div');
        button.style.color = 'rgb(25,25,25)';
        button.style.fontFamily = 'Roboto,Arial,sans-serif';
        button.style.fontSize = '16px';
        button.style.lineHeight = '38px';
        button.innerHTML = icon;
        ui.appendChild(button);

        button.addEventListener('click', function () {
            callback();
        });
    };

    /**
     * Remove all markers from map.
     */
    function clearMarkers() {
        setMapOnAll(null);
        markers = [];
    }

    /**
     * Set markers map as null.
     * @param map
     */
    function setMapOnAll(map) {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    }

    /**
     * Create a marker in the map.
     * @param latitude
     * @param longitude
     */
    function setPin(latitude, longitude) {
        var myLatLng = {lat: latitude, lng: longitude};
        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map
        });

        markers.push(marker);
    }

    var initPin = function() {
        map = new google.maps.Map(document.getElementById('map-pin'), {
            center: getCenter(),
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            rotateControl: false
        });

        map.setTilt(0);

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['marker']
            }
        });

        drawingManager.setMap(map);

        var removeMarkerButton = document.createElement('div');

        addCustomControl(removeMarkerButton, 'marker');

        removeMarkerButton.index = 1;

        map.controls[google.maps.ControlPosition.TOP_CENTER].push(removeMarkerButton);

        google.maps.event.addListener(drawingManager, 'markercomplete', addMarker);

        google.maps.event.addListener(map, 'zoom_changed', setSelectedPinZoom);

        addTooltips();
    };

    var setSelectedPinZoom = function() {
        $("input[name='map_pin_zoom']").val(map.getZoom());
    };

    var setSelectedPin = function() {
        var latPinEl = $("input[name='map_pin_lat']");
        var lngPinEl = $("input[name='map_pin_lng']");

        var latitude = $("input[name='latitude']").val();
        var longitude = $("input[name='longitude']").val();

        var pinLatitude = latPinEl.val();
        var pinLongitude = lngPinEl.val();

        if (pinLatitude.length && pinLongitude.length) {
            latitude = pinLatitude;
            longitude = pinLongitude;
        }

        if(latitude.length && longitude.length) {
            latPinEl.val(latitude);
            lngPinEl.val(longitude);

            clearMarkers();

            setPin(parseFloat(latitude), parseFloat(longitude));

            if (markers.hasOwnProperty(0)) {
                var zoomEl = $("input[name='map_pin_zoom']");
                var zoom = zoomEl.val();

                if(zoom.length) {
                    map.panTo(markers[0].position);
                    map.setZoom(parseInt(zoom));
                } else {
                    if($("#route").val().length) {
                        zoomEl.val(16);
                        map.panTo(markers[0].position);
                        map.setZoom(16);
                    } else {
                        map.setZoom(4);
                        zoomEl.val(4);
                    }
                }
            }
        } else {
            map.setCenter(new google.maps.LatLng(Utils.getUSACenter().lat, Utils.getUSACenter().lng));
        }
    };

    function reset() {
        clearMarkers();
    }

    if (window.MapController === undefined) {
        window.MapController = {};
    }

    if (window.MapController.CompsPin === undefined) {
        window.MapController.CompsPin = {};
    }

    MapController.CompsPin.init = initPin;
    MapController.CompsPin.setSelectedPin = setSelectedPin;
    MapController.CompsPin.reset = reset;

})();